import React from 'react'

import { ArrowDirectionIcon } from '@application/Interfaces/Icons'
import { Html } from '@src/Application/Interfaces/Atoms/Html'
import { Image } from '@src/Application/Interfaces/Atoms/Image'
import { useTranslation } from '@src/Application/Interfaces/Hooks/useTranslation'
import { HelpCenterCategory } from '@src/Application/Types/ComponentTypes'
import { getPageUrl } from '@src/Application/Utils/generalUtils'

import {
    ArticleTitle,
    BottomWrapper,
    Box,
    Description,
    Link,
    Title,
    TitleWrapper,
    TopWrapper,
    ViewAllLink,
} from './CategoryBox.styled'

export const CategoryBox = (props: HelpCenterCategory): JSX.Element => {
    const { title, image, categoryUrl, help_centers: helpCenters, description, imageAnimation } = props
    const { t } = useTranslation()

    return (
        <Box>
            <TopWrapper>
                <TitleWrapper>
                    <div>
                        <Title>{title}</Title>
                        {description && (
                            <Description>
                                <Html content={description.data.childMarkdownRemark.html} />
                            </Description>
                        )}
                    </div>
                    <Image image={image} imageAnimation={imageAnimation} />
                </TitleWrapper>

                {helpCenters.slice(0, 3).map((item) => (
                    <ArticleTitle key={item.pageUrl}>
                        <Link to={getPageUrl(item)}>{item.title.data?.title}</Link>
                    </ArticleTitle>
                ))}
            </TopWrapper>
            <BottomWrapper>
                <ViewAllLink to={categoryUrl}>
                    {t('seeAllXArticles').replace('%count%', `${helpCenters.length}`)}{' '}
                    <ArrowDirectionIcon colorCode="p500" />
                </ViewAllLink>
            </BottomWrapper>
        </Box>
    )
}
